import { scoped, Lifecycle, instancePerContainerCachingFactory as perRestaurantFactory, } from "tsyringe";
export { perRestaurantFactory };
export const perRestaurant = () => scoped(Lifecycle.ContainerScoped);
